
import state from './memberState.js'
import mutations from './memberMutations.js'
import actions from './memberAction.js'
import getters from './memberGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

